function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { TableList, Typography } from 'seagull';
import { emptyCell } from "../../../../constants";
import { VendorLineItem, CustomerLineItem } from "./LineItem";
import { columnDefs, headerItems, HeaderDateIndicator } from "./ScheduledInvoice.utils";
import styles from "./ScheduledInvoice.module.scss";
import { utils } from "../../../../utils";
export default function ScheduledInvoice(props) {
  const ScheduledInvoiceTableRow = props.isVendor ? VendorLineItem : CustomerLineItem;
  return /*#__PURE__*/React.createElement(TableList.Provider, {
    variant: "minimal",
    columnDefs: columnDefs
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.root,
    "data-testid": "scheduled-invoice"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.infoRow
  }, /*#__PURE__*/React.createElement(HeaderDateIndicator, {
    label: "Issue date",
    date: props.issueDate,
    testid: "scheduled-invoice-issue-date"
  }), /*#__PURE__*/React.createElement(HeaderDateIndicator, {
    label: "Due on",
    date: props.paymentDate,
    testid: "scheduled-invoice-due-on-date"
  })), /*#__PURE__*/React.createElement(TableList.Header, {
    className: styles.header,
    bgColor: "darkGray",
    items: headerItems
  }), props.rowsProps.length ? /*#__PURE__*/React.createElement("div", {
    "data-testid": "scheduled-invoice-rows-container"
  }, props.rowsProps.map(rowProps => /*#__PURE__*/React.createElement(ScheduledInvoiceTableRow, _extends({
    key: rowProps.charge.id
  }, rowProps, {
    addedLineItemId: props.addedLineItemId
  }))), /*#__PURE__*/React.createElement(TableList.Row, {
    className: styles.footerRow,
    items: [emptyCell, emptyCell, {
      value: /*#__PURE__*/React.createElement(Typography, {
        variant: "paragraph1"
      }, "Subtotal")
    }, emptyCell, {
      value: /*#__PURE__*/React.createElement(Typography, {
        weight: "normal"
      }, utils.formatDollarAmount(props.totalAmount))
    }, emptyCell, emptyCell],
    "data-testid": "total-amount-row"
  })) : /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph1",
    className: styles.empty
  }, "Services included in your next invoice will appear here.", /*#__PURE__*/React.createElement("br", null), "You can add services by clicking on \"Billing Control\" at the top right.")));
}